import { render } from "./FlightPassengersBanner.vue?vue&type=template&id=8f407194"
import script from "./FlightPassengersBanner.vue?vue&type=script&lang=js"
export * from "./FlightPassengersBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__